export const getScourPOA = (scourCriticalCategory) => {
  let scourPOARequired = null;
  if (scourCriticalCategory == "--") {
    scourPOARequired = "0";
  } else if (
    scourCriticalCategory == "A" ||
    scourCriticalCategory == "B" ||
    scourCriticalCategory == "C" ||
    scourCriticalCategory == "D"
  ) {
    scourPOARequired = "Y";
  } else {
    scourPOARequired = "N";
  }
  return scourPOARequired;
};
export const isStructureUnitIn500YrFp = (structureUnitKey, underWaterInspections) => {
  const index = underWaterInspections?.findIndex((underWaterInspection) => {
    return underWaterInspection.strUnitKey === structureUnitKey;
  });
  return index > -1;
};
